import React, { useState, useEffect, useCallback } from 'react';


const LoginForm = ({ onLogin, error, isLoading }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(credentials);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <form onSubmit={handleSubmit} style={{
        maxWidth: '400px',
        width: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '16px',
        padding: '2rem',
        backdropFilter: 'blur(10px)'
      }}>
        <h1 style={{
          fontSize: '1.5rem',
          fontWeight: '700',
          color: '#1f2937',
          marginBottom: '1.5rem',
          textAlign: 'center'
        }}>
          Admin Login
        </h1>

        {error && (
          <div style={{
            background: '#fef2f2',
            border: '1px solid #fecaca',
            color: '#dc2626',
            padding: '12px',
            borderRadius: '6px',
            marginBottom: '1rem',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: '1rem' }}>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '0.5rem'
          }}>
            Username
          </label>
          <input
            type="text"
            value={credentials.username}
            onChange={(e) => setCredentials(prev => ({ ...prev, username: e.target.value }))}
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '14px',
              boxSizing: 'border-box'
            }}
            required
          />
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '0.5rem'
          }}>
            Password
          </label>
          <input
            type="password"
            value={credentials.password}
            onChange={(e) => setCredentials(prev => ({ ...prev, password: e.target.value }))}
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '14px',
              boxSizing: 'border-box'
            }}
            required
          />
        </div>

        <button
          type="submit"
          disabled={isLoading}
          style={{
            width: '100%',
            padding: '0.75rem',
            background: isLoading ? '#9ca3af' : '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: isLoading ? 'not-allowed' : 'pointer'
          }}
        >
          {isLoading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
};


const InvestmentDetailModal = ({ investment, onClose, onUpdate }) => {
  const [status, setStatus] = useState(investment.status);
  const [notes, setNotes] = useState(investment.notes || '');
  const [contactedBy, setContactedBy] = useState(investment.contacted_by || '');
  const [updating, setUpdating] = useState(false);

  const handleUpdate = async () => {
    setUpdating(true);
    try {
      await onUpdate(investment.id, { status, notes, contactedBy });
      onClose();
    } catch (error) {
      console.error('Update error:', error);
    } finally {
      setUpdating(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '2rem',
        maxWidth: '600px',
        width: '90%',
        maxHeight: '80vh',
        overflowY: 'auto'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1.5rem'
        }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', margin: 0 }}>
            {investment.type === 'invest' ? 'Investment' : 'Sponsorship'} Details
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              color: '#6b7280'
            }}
          >
            ×
          </button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
          <div>
            <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Name</label>
            <p style={{ margin: '0.25rem 0 0 0', color: '#6b7280' }}>{investment.name}</p>
          </div>
          <div>
            <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Email</label>
            <p style={{ margin: '0.25rem 0 0 0', color: '#6b7280' }}>{investment.email}</p>
          </div>
          <div>
            <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Phone</label>
            <p style={{ margin: '0.25rem 0 0 0', color: '#6b7280' }}>{investment.phone}</p>
          </div>
          <div>
            <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Company</label>
            <p style={{ margin: '0.25rem 0 0 0', color: '#6b7280' }}>{investment.company || 'N/A'}</p>
          </div>
          {investment.pledge_amount && (
            <div>
              <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Pledge Amount</label>
              <p style={{ margin: '0.25rem 0 0 0', color: '#6b7280' }}>{formatCurrency(investment.pledge_amount)}</p>
            </div>
          )}
          {investment.shirt_size && (
            <div>
              <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Shirt Size</label>
              <p style={{ margin: '0.25rem 0 0 0', color: '#6b7280' }}>{investment.shirt_size}</p>
            </div>
          )}
          {investment.shirt_color && (
            <div>
              <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Shirt Color</label>
              <p style={{ margin: '0.25rem 0 0 0', color: '#6b7280' }}>{investment.shirt_color}</p>
            </div>
          )}
          <div>
            <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Submitted</label>
            <p style={{ margin: '0.25rem 0 0 0', color: '#6b7280' }}>
              {new Date(investment.submitted_at).toLocaleString()}
            </p>
          </div>
          {investment.contacted_at && (
            <div>
              <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Contacted</label>
              <p style={{ margin: '0.25rem 0 0 0', color: '#6b7280' }}>
                {new Date(investment.contacted_at).toLocaleString()}
              </p>
            </div>
          )}
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '0.5rem'
          }}>
            Status
          </label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{
              width: '100%',
              padding: '0.5rem',
              border: '1px solid #d1d5db',
              borderRadius: '4px',
              fontSize: '14px'
            }}
          >
            <option value="pending">Pending</option>
            <option value="contacted">Contacted</option>
            <option value="in_progress">In Progress</option>
            <option value="completed">Completed</option>
            <option value="declined">Declined</option>
          </select>
        </div>

        {status === 'contacted' && (
          <div style={{ marginBottom: '1rem' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '0.5rem'
            }}>
              Contacted By
            </label>
            <input
              type="text"
              value={contactedBy}
              onChange={(e) => setContactedBy(e.target.value)}
              placeholder="Enter your name"
              style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid #d1d5db',
                borderRadius: '4px',
                fontSize: '14px',
                boxSizing: 'border-box'
              }}
            />
          </div>
        )}

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '0.5rem'
          }}>
            Notes
          </label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Add notes about this inquiry..."
            rows="4"
            style={{
              width: '100%',
              padding: '0.5rem',
              border: '1px solid #d1d5db',
              borderRadius: '4px',
              fontSize: '14px',
              resize: 'vertical',
              boxSizing: 'border-box'
            }}
          />
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '0.5rem 1rem',
              background: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleUpdate}
            disabled={updating}
            style={{
              padding: '0.5rem 1rem',
              background: updating ? '#9ca3af' : '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: updating ? 'not-allowed' : 'pointer'
            }}
          >
            {updating ? 'Updating...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  );
};


const AdminDashboard = () => {
  const [aerospaceSubscribers, setAerospaceSubscribers] = useState([]);
  const [armorySubscribers, setArmorySubscribers] = useState([]);
  const [investments, setInvestments] = useState([]);
  const [activeTab, setActiveTab] = useState('aerospace');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);
  const [emailSending, setEmailSending] = useState({});
  const [selectedInvestment, setSelectedInvestment] = useState(null);
  const [investmentFilters, setInvestmentFilters] = useState({ status: '', type: '' });

  const API_BASE_URL = 'http://localhost:3001/api';

  
  const [authToken, setAuthToken] = useState('');

  
  const authenticatedFetch = useCallback(async (url, options = {}) => {
    return fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      }
    });
  }, [authToken]);

  
  useEffect(() => {
    const checkAuth = async () => {
      
      setAuthLoading(false);
    };

    checkAuth();
  }, []);

  
  const handleLogin = async (credentials) => {
    setLoginLoading(true);
    setLoginError('');

    try {
      const response = await fetch(`${API_BASE_URL}/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      });

      const data = await response.json();

      if (data.success) {
        setAuthToken(data.token);
        setUser(data.user);
        setIsAuthenticated(true);
      } else {
        setLoginError(data.error || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      setLoginError('Network error. Please try again.');
    } finally {
      setLoginLoading(false);
    }
  };

  
  const handleLogout = () => {
    setAuthToken('');
    setUser(null);
    setIsAuthenticated(false);
    setAerospaceSubscribers([]);
    setArmorySubscribers([]);
    setInvestments([]);
  };

  
  const fetchSubscribers = useCallback(async (type) => {
    setLoading(true);
    setError('');
    
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/admin/subscribers/${type}`);
      const data = await response.json();
      
      if (response.status === 401 || response.status === 403) {
        handleLogout();
        return;
      }
      
      if (data.success) {
        if (type === 'aerospace') {
          setAerospaceSubscribers(data.subscribers);
        } else {
          setArmorySubscribers(data.subscribers);
        }
      } else {
        setError(`Failed to fetch ${type} subscribers`);
      }
    } catch (err) {
      setError(`Network error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }, [authenticatedFetch]);

  
  const fetchInvestments = useCallback(async () => {
    setLoading(true);
    setError('');
    
    try {
      const queryParams = new URLSearchParams();
      if (investmentFilters.status) queryParams.append('status', investmentFilters.status);
      if (investmentFilters.type) queryParams.append('type', investmentFilters.type);
      
      const response = await authenticatedFetch(`${API_BASE_URL}/admin/investments?${queryParams}`);
      const data = await response.json();
      
      if (response.status === 401 || response.status === 403) {
        handleLogout();
        return;
      }
      
      if (data.success) {
        setInvestments(data.investments);
      } else {
        setError('Failed to fetch investments');
      }
    } catch (err) {
      setError(`Network error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }, [authenticatedFetch, investmentFilters.status, investmentFilters.type]);

  
  const updateInvestment = async (id, updateData) => {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/admin/investments/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(updateData)
      });
      
      const data = await response.json();
      
      if (data.success) {
        
        await fetchInvestments();
      } else {
        setError(`Failed to update investment: ${data.error}`);
      }
    } catch (err) {
      setError(`Network error: ${err.message}`);
    }
  };

  
  const resendWelcomeEmail = async (type, subscriberId) => {
    const emailKey = `${type}-${subscriberId}`;
    setEmailSending(prev => ({ ...prev, [emailKey]: true }));
    
    try {
      const response = await authenticatedFetch(
        `${API_BASE_URL}/admin/resend-welcome/${type}/${subscriberId}`,
        { method: 'POST' }
      );
      
      const data = await response.json();
      
      if (data.success) {
        await fetchSubscribers(type);
      } else {
        setError(`Failed to resend email: ${data.error}`);
      }
    } catch (err) {
      setError(`Network error: ${err.message}`);
    } finally {
      setEmailSending(prev => ({ ...prev, [emailKey]: false }));
    }
  };

  
  const exportToCsv = async (type) => {
    try {
      let url = `${API_BASE_URL}/admin/export/${type}`;
      
      if (type === 'investments') {
        const queryParams = new URLSearchParams();
        if (investmentFilters.status) queryParams.append('status', investmentFilters.status);
        if (investmentFilters.type) queryParams.append('type', investmentFilters.type);
        url = `${API_BASE_URL}/admin/export/investments?${queryParams}`;
      }
      
      const response = await authenticatedFetch(url);
      
      if (response.status === 401 || response.status === 403) {
        handleLogout();
        return;
      }
      
      if (response.ok) {
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `${type}_${Date.now()}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
      } else {
        setError('Failed to export data');
      }
    } catch (err) {
      setError(`Export error: ${err.message}`);
    }
  };

  
  useEffect(() => {
    if (isAuthenticated) {
      if (activeTab === 'investments') {
        fetchInvestments();
      } else {
        fetchSubscribers(activeTab);
      }
    }
  }, [activeTab, isAuthenticated, fetchInvestments, fetchSubscribers]);

  
  if (authLoading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ color: 'white', fontSize: '1.2rem' }}>Loading...</div>
      </div>
    );
  }

  
  if (!isAuthenticated) {
    return <LoginForm onLogin={handleLogin} error={loginError} isLoading={loginLoading} />;
  }

  const getCurrentData = () => {
    switch (activeTab) {
      case 'aerospace':
        return aerospaceSubscribers;
      case 'armory':
        return armorySubscribers;
      case 'investments':
        return investments;
      default:
        return [];
    }
  };

  const data = getCurrentData();

  const tabStyle = (isActive) => ({
    padding: '12px 24px',
    background: isActive ? '#3b82f6' : 'transparent',
    color: isActive ? 'white' : '#6b7280',
    border: '1px solid #3b82f6',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.3s ease'
  });

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '1rem',
    backgroundColor: 'white',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  };

  const thStyle = {
    background: '#f3f4f6',
    padding: '12px',
    textAlign: 'left',
    fontWeight: '600',
    fontSize: '14px',
    color: '#374151',
    borderBottom: '1px solid #e5e7eb'
  };

  const tdStyle = {
    padding: '12px',
    borderBottom: '1px solid #e5e7eb',
    fontSize: '14px',
    color: '#6b7280'
  };

  const StatusBadge = ({ status }) => {
    const colors = {
      pending: { bg: '#fef3c7', color: '#d97706' },
      contacted: { bg: '#dbeafe', color: '#1d4ed8' },
      in_progress: { bg: '#fde68a', color: '#d97706' },
      completed: { bg: '#dcfce7', color: '#166534' },
      declined: { bg: '#fecaca', color: '#dc2626' }
    };

    const statusColor = colors[status] || colors.pending;

    return (
      <span style={{
        padding: '4px 8px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: '500',
        background: statusColor.bg,
        color: statusColor.color,
        textTransform: 'capitalize'
      }}>
        {status.replace('_', ' ')}
      </span>
    );
  };

  const EmailStatusBadge = ({ sent, type, subscriberId }) => {
    const emailKey = `${type}-${subscriberId}`;
    const isSending = emailSending[emailKey];

    if (sent) {
      return (
        <span style={{
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: '500',
          background: '#dcfce7',
          color: '#166534',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px'
        }}>
          ✓ Sent
        </span>
      );
    }

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: '500',
          background: '#fef3c7',
          color: '#d97706'
        }}>
          Not Sent
        </span>
        <button
          onClick={() => resendWelcomeEmail(type, subscriberId)}
          disabled={isSending}
          style={{
            padding: '4px 8px',
            background: isSending ? '#9ca3af' : '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '11px',
            cursor: isSending ? 'not-allowed' : 'pointer',
            fontWeight: '500'
          }}
        >
          {isSending ? 'Sending...' : 'Resend'}
        </button>
      </div>
    );
  };

  const renderInvestmentStats = () => {
    const totalInvestments = investments.filter(i => i.type === 'invest').length;
    const totalSponsorships = investments.filter(i => i.type === 'sponsor').length;
    const pendingCount = investments.filter(i => i.status === 'pending').length;
    const totalPledged = investments
      .filter(i => i.type === 'sponsor' && i.pledge_amount)
      .reduce((sum, i) => sum + parseFloat(i.pledge_amount), 0);

    return (
      <>
        <div style={{
          background: '#f0f9ff',
          border: '1px solid #7dd3fc',
          borderRadius: '8px',
          padding: '1rem',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#0369a1'
          }}>
            {totalInvestments}
          </div>
          <div style={{
            fontSize: '14px',
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Investments
          </div>
        </div>

        <div style={{
          background: '#f0fdf4',
          border: '1px solid #86efac',
          borderRadius: '8px',
          padding: '1rem',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#15803d'
          }}>
            {totalSponsorships}
          </div>
          <div style={{
            fontSize: '14px',
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Sponsorships
          </div>
        </div>

        <div style={{
          background: '#fef3c7',
          border: '1px solid #fcd34d',
          borderRadius: '8px',
          padding: '1rem',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#d97706'
          }}>
            {pendingCount}
          </div>
          <div style={{
            fontSize: '14px',
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Pending
          </div>
        </div>

        <div style={{
          background: '#f0f9ff',
          border: '1px solid #7dd3fc',
          borderRadius: '8px',
          padding: '1rem',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#0369a1'
          }}>
            ${totalPledged.toLocaleString()}
          </div>
          <div style={{
            fontSize: '14px',
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Total Pledged
          </div>
        </div>
      </>
    );
  };

  const renderSubscriberStats = () => {
    const subscribers = activeTab === 'aerospace' ? aerospaceSubscribers : armorySubscribers;
    
    const stats = [
      <div key="total" style={{
        background: '#f0f9ff',
        border: '1px solid #7dd3fc',
        borderRadius: '8px',
        padding: '1rem',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '14px',
          color: '#64748b',
          textTransform: 'uppercase',
          letterSpacing: '0.05em'
        }}>
          Welcome Emails Sent
        </div>
      </div>
    ];

    if (activeTab === 'armory') {
      stats.push(
        <div key="consumers" style={{
          background: '#f0fdf4',
          border: '1px solid #86efac',
          borderRadius: '8px',
          padding: '1rem',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#15803d'
          }}>
            {subscribers.filter(s => s.user_type === 'consumer').length}
          </div>
          <div style={{
            fontSize: '14px',
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Consumers
          </div>
        </div>,

        <div key="vendors" style={{
          background: '#fef3c7',
          border: '1px solid #fcd34d',
          borderRadius: '8px',
          padding: '1rem',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#d97706'
          }}>
            {subscribers.filter(s => s.user_type === 'vendor').length}
          </div>
          <div style={{
            fontSize: '14px',
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Vendors
          </div>
        </div>
      );
    }

    return stats;
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '2rem'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '16px',
        padding: '2rem',
        backdropFilter: 'blur(10px)'
      }}>
        {}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '2rem' 
        }}>
          <div>
            <h1 style={{
              fontSize: '2rem',
              fontWeight: '700',
              color: '#1f2937',
              marginBottom: '0.5rem'
            }}>
              Newsletter Admin Dashboard
            </h1>
            <p style={{
              color: '#6b7280',
              fontSize: '1rem'
            }}>
              Welcome, {user?.username}
            </p>
          </div>
          <button
            onClick={handleLogout}
            style={{
              padding: '8px 16px',
              background: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            Logout
          </button>
        </div>

        {}
        <div style={{
          display: 'flex',
          gap: '1rem',
          marginBottom: '2rem'
        }}>
          <button
            onClick={() => setActiveTab('aerospace')}
            style={tabStyle(activeTab === 'aerospace')}
          >
            Aerospace Newsletter ({aerospaceSubscribers.length})
          </button>
          <button
            onClick={() => setActiveTab('armory')}
            style={tabStyle(activeTab === 'armory')}
          >
            Armory Newsletter ({armorySubscribers.length})
          </button>
          <button
            onClick={() => setActiveTab('investments')}
            style={tabStyle(activeTab === 'investments')}
          >
            Investments ({investments.length})
          </button>
        </div>

        {}
        {activeTab === 'investments' && (
          <div style={{
            display: 'flex',
            gap: '1rem',
            marginBottom: '1rem',
            padding: '1rem',
            background: '#f9fafb',
            borderRadius: '8px'
          }}>
            <div>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem'
              }}>
                Status
              </label>
              <select
                value={investmentFilters.status}
                onChange={(e) => setInvestmentFilters(prev => ({ ...prev, status: e.target.value }))}
                style={{
                  padding: '0.5rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              >
                <option value="">All Statuses</option>
                <option value="pending">Pending</option>
                <option value="contacted">Contacted</option>
                <option value="in_progress">In Progress</option>
                <option value="completed">Completed</option>
                <option value="declined">Declined</option>
              </select>
            </div>
            <div>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem'
              }}>
                Type
              </label>
              <select
                value={investmentFilters.type}
                onChange={(e) => setInvestmentFilters(prev => ({ ...prev, type: e.target.value }))}
                style={{
                  padding: '0.5rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              >
                <option value="">All Types</option>
                <option value="invest">Investments</option>
                <option value="sponsor">Sponsorships</option>
              </select>
            </div>
          </div>
        )}

        {}
        <div style={{
          display: 'flex',
          gap: '1rem',
          marginBottom: '1rem'
        }}>
          <button
            onClick={() => activeTab === 'investments' ? fetchInvestments() : fetchSubscribers(activeTab)}
            disabled={loading}
            style={{
              padding: '8px 16px',
              background: '#10b981',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1
            }}
          >
            {loading ? 'Refreshing...' : 'Refresh Data'}
          </button>
          <button
            onClick={() => exportToCsv(activeTab)}
            style={{
              padding: '8px 16px',
              background: '#8b5cf6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            Export to CSV
          </button>
        </div>

        {}
        {error && (
          <div style={{
            background: '#fef2f2',
            border: '1px solid #fecaca',
            color: '#dc2626',
            padding: '12px',
            borderRadius: '6px',
            marginBottom: '1rem'
          }}>
            {error}
          </div>
        )}

        {}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem',
          marginBottom: '2rem'
        }}>
          {activeTab === 'investments' ? renderInvestmentStats() : renderSubscriberStats()}
        </div>

        {}
        <div style={{ overflowX: 'auto' }}>
          {loading ? (
            <div style={{
              textAlign: 'center',
              padding: '3rem',
              color: '#6b7280'
            }}>
              Loading data...
            </div>
          ) : data.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '3rem',
              color: '#6b7280'
            }}>
              No {activeTab === 'investments' ? 'investment inquiries' : 'subscribers'} found
            </div>
          ) : (
            <table style={tableStyle}>
              <thead>
                <tr>
                  {activeTab === 'investments' ? (
                    <>
                      <th style={thStyle}>Name</th>
                      <th style={thStyle}>Email</th>
                      <th style={thStyle}>Phone</th>
                      <th style={thStyle}>Type</th>
                      <th style={thStyle}>Pledge Amount</th>
                      <th style={thStyle}>Status</th>
                      <th style={thStyle}>Submitted</th>
                      <th style={thStyle}>Actions</th>
                    </>
                  ) : (
                    <>
                      <th style={thStyle}>Name</th>
                      <th style={thStyle}>Email</th>
                      {activeTab === 'aerospace' && <th style={thStyle}>Company</th>}
                      {activeTab === 'armory' && <th style={thStyle}>Calibers</th>}
                      {activeTab === 'armory' && <th style={thStyle}>User Type</th>}
                      {activeTab === 'armory' && <th style={thStyle}>Store Name</th>}
                      <th style={thStyle}>Welcome Email</th>
                      <th style={thStyle}>Subscribed</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item.id}>
                    {activeTab === 'investments' ? (
                      <>
                        <td style={tdStyle}>{item.name}</td>
                        <td style={tdStyle}>{item.email}</td>
                        <td style={tdStyle}>{item.phone}</td>
                        <td style={tdStyle}>
                          <span style={{
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: '500',
                            background: item.type === 'invest' ? '#dbeafe' : '#fef3c7',
                            color: item.type === 'invest' ? '#1d4ed8' : '#d97706',
                            textTransform: 'capitalize'
                          }}>
                            {item.type}
                          </span>
                        </td>
                        <td style={tdStyle}>
                          {item.pledge_amount 
                            ? new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: 'USD'
                              }).format(item.pledge_amount)
                            : 'N/A'
                          }
                        </td>
                        <td style={tdStyle}>
                          <StatusBadge status={item.status} />
                        </td>
                        <td style={tdStyle}>
                          {new Date(item.submitted_at).toLocaleDateString()}
                        </td>
                        <td style={tdStyle}>
                          <button
                            onClick={() => setSelectedInvestment(item)}
                            style={{
                              padding: '4px 8px',
                              background: '#3b82f6',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              fontSize: '12px',
                              cursor: 'pointer'
                            }}
                          >
                            View Details
                          </button>
                        </td>
                      </>
                    ) : (
                      <>
                        <td style={tdStyle}>
                          {item.first_name} {item.last_name}
                        </td>
                        <td style={tdStyle}>{item.email}</td>
                        {activeTab === 'aerospace' && (
                          <td style={tdStyle}>{item.company || 'N/A'}</td>
                        )}
                        {activeTab === 'armory' && (
                          <td style={tdStyle}>{item.calibers}</td>
                        )}
                        {activeTab === 'armory' && (
                          <td style={tdStyle}>
                            <span style={{
                              padding: '4px 8px',
                              borderRadius: '4px',
                              fontSize: '12px',
                              fontWeight: '500',
                              background: item.user_type === 'vendor' ? '#fef3c7' : '#dbeafe',
                              color: item.user_type === 'vendor' ? '#d97706' : '#1d4ed8'
                            }}>
                              {item.user_type}
                            </span>
                          </td>
                        )}
                        {activeTab === 'armory' && (
                          <td style={tdStyle}>{item.store_name || 'N/A'}</td>
                        )}
                        <td style={tdStyle}>
                          <EmailStatusBadge 
                            sent={item.welcome_email_sent} 
                            type={activeTab}
                            subscriberId={item.id}
                          />
                        </td>
                        <td style={tdStyle}>
                          {new Date(item.subscribed_at).toLocaleDateString()}
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {}
      {selectedInvestment && (
        <InvestmentDetailModal
          investment={selectedInvestment}
          onClose={() => setSelectedInvestment(null)}
          onUpdate={updateInvestment}
        />
      )}
    </div>
  );
};

export default AdminDashboard;
          